// extracted by css-extract-rspack-plugin
export default {"Header":"ExpressionWidgetHeader-module__Header___zQn2C","HeaderButton":"ExpressionWidgetHeader-module__HeaderButton___ESKGM"};